import { render, staticRenderFns } from "./VentasListaCarritoNoEntregadas.vue?vue&type=template&id=6df7079c&"
import script from "./VentasListaCarritoNoEntregadas.vue?vue&type=script&lang=js&"
export * from "./VentasListaCarritoNoEntregadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports